/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
/**
 * Check if a given object implements the NetworkResponse interface.
 */
export function instanceOfNetworkResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function NetworkResponseFromJSON(json) {
    return NetworkResponseFromJSONTyped(json, false);
}
export function NetworkResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': json['active'],
        'allowedScreenPositions': !exists(json, 'allowedScreenPositions') ? undefined : json['allowedScreenPositions']
    };
}
export function NetworkResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metaData': MetaDataToJSON(value.metaData),
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'allowedScreenPositions': value.allowedScreenPositions
    };
}
